import React from "react";
import { GrLinkNext } from "react-icons/gr";
import { GrLinkPrevious } from "react-icons/gr";
import { LuFilter } from "react-icons/lu";
import { IoAddCircleOutline } from "react-icons/io5";
import { TfiReload } from "react-icons/tfi";
import ColumnsSelector from "./ColumnsSelector.jsx";
import Buscador from "./Buscador.jsx";

const ProductsHeader = ({
  columns,
  callReload,
  callAdd,
  selectedColumns,
  changeSelectedColumns,
}) => {
  return (
    <div className="flex flex-col gap-4 px-4 py-2 w-full">
      <Buscador />

      <div className="flex gap-4 mb-2 justify-between flex-wrap">
        <div className="flex gap-1 w-full">
          <button className="border border-solid border-[var(--var-gris)] p-[10px] text-[18px] flex gap-1 justify-center items-center text-black rounded-md">
            <GrLinkPrevious />
          </button>
          <button className="border border-solid border-[var(--var-gris)] p-[10px] text-[18px] flex gap-1 justify-center items-center text-black rounded-md">
            <GrLinkNext />
          </button>
        </div>

        <div className="flex gap-1">
          <button className="border border-solid border-[var(--var-gris)] p-[10px] text-[18px] flex gap-1 justify-center items-center text-black rounded-md">
            <LuFilter />
            Filters
          </button>
          <ColumnsSelector
            columns={columns}
            selectedColumns={selectedColumns}
            changeSelectedColumns={changeSelectedColumns}
          />
          <button
            className="border border-solid border-[var(--var-gris)] p-[10px]  text-[18px] flex gap-1 justify-center items-center text-black rounded-md hover:bg-sky-500 hover:text-white focus:bg-sky-500 focus:text-white"
            onClick={() => callAdd()}
          >
            <IoAddCircleOutline />
            Add Product
          </button>
        </div>

        <div className="ml-auto flex gap-1 gap-4">
          <button
            className="h-[50px] border border-solid border-[var(--var-gris)] p-[10px] text-[18px] flex gap-1 justify-center items-center text-black rounded-md  hover:bg-sky-500 hover:text-white focus:bg-sky-500 focus:text-white"
            onClick={() => callReload()}
          >
            <TfiReload />
          </button>

          {/*
                         < button className="border border-solid border-[var(--var-gris)] p-[10px] text-[18px] flex gap-1 justify-center items-center text-black rounded-md download-button">
                        <PiDownloadSimpleBold />
                    </button>
                    < button className="border border-solid border-[var(--var-gris)] p-[10px] text-[18px] flex gap-1 justify-center items-center text-black rounded-md print-button">
                        <IoPrintOutline />

                    </button>
                        <button className="border border-solid border-[var(--var-gris)] p-[10px] text-[18px] flex gap-1 justify-center items-center text-black rounded-md download-button">
                        */}
        </div>
      </div>
    </div>
  );
};

export default ProductsHeader;
